var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-parallax',{staticStyle:{"filter":"brightness(90%)"},attrs:{"height":_vm.$vuetify.breakpoint.smAndDown ? '150' : '300',"src":"/assets/parallax/parallax-1.jpg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }